module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideBar"
  }, [_c('div', {
    staticClass: "sideBarTop"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('p', {
    staticClass: "hello flex flex-align-center flex-pack-center"
  }, [_vm._v("Hello,")]), _vm._v(" "), _c('p', {
    staticClass: "storeName flex flex-align-center flex-pack-center",
    domProps: {
      "textContent": _vm._s(_vm.storeData.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "changeStore flex flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "iconfont icon-qihuan"
  }), _c('router-link', {
    attrs: {
      "tag": "span",
      "to": "/store",
      "replace": ""
    }
  }, [_vm._v("切换店铺")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navMenu"
  }, [_c('ul', {
    staticClass: "menuList"
  }, _vm._l((_vm.sideBarData), function(item, ind) {
    return _c('li', {
      staticClass: "subMenu",
      class: {
        isOpen1: (item.isOpen && item.son.length == 1 && _vm.btn),
        isOpen2: (item.isOpen && item.son.length == 2 && _vm.btn),
        isOpen3: (item.isOpen && item.son.length == 3 && _vm.btn),
        isOpen401: (item.isOpen && item.son.length == 4 && _vm.btn),
        isOpen402: (item.isOpen && item.son.length == 5 && _vm.btn),
        isOpen403: (item.isOpen && item.son.length == 6 && _vm.btn),
        isOpen404: (item.isOpen && item.son.length == 7 && _vm.btn),
        isOpen405: (item.isOpen && item.son.length == 8 && _vm.btn),
        isOpen403_: (item.isOpen && item.fixedSon && _vm.btn),
        'title-active': item.isOpen
      }
    }, [_c('div', {
      staticClass: "subMenuTitle flex flex-align-center",
      on: {
        "click": function($event) {
          return _vm.handle(item, ind)
        }
      }
    }, [_c('i', {
      class: item.iconClass
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), (item.son.length) ? _c('ul', {
      staticClass: "subSonMenu"
    }, [_vm._l((item.son), function(son, sonInd) {
      return _c('router-link', {
        key: sonInd,
        staticClass: "menuItem",
        attrs: {
          "tag": "li",
          "to": son.routeName,
          "active-class": 'son-active'
        }
      }, [_c('span', {
        staticClass: "menuItemSpan",
        domProps: {
          "textContent": _vm._s(son.name)
        }
      })])
    }), _vm._v(" "), _vm._l((item.fixedSon), function(fixedSonItem, fixedSonItemInd) {
      return _c('li', {
        staticClass: "menuItem",
        on: {
          "click": _vm.goInv
        }
      }, [_c('span', {
        staticClass: "menuItemSpan",
        domProps: {
          "textContent": _vm._s(fixedSonItem.name)
        }
      })])
    })], 2) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2f8e1102","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/sideBar/sideBar.vue
// module id = 936
// module chunks = 1